var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 34,
    height: 34,
    rx: 17,
    stroke: "#4B57E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1136 19.1928C22.9331 19.1928 22.7868 19.3391 22.7868 19.5196V22.4219C22.7861 22.9633 22.3475 23.402 21.8061 23.4025H12.6344C12.093 23.402 11.6544 22.9633 11.6537 22.4219V13.9039C11.6544 13.3626 12.093 12.9239 12.6344 12.9233H15.5367C15.7172 12.9233 15.8635 12.777 15.8635 12.5964C15.8635 12.416 15.7172 12.2695 15.5367 12.2695H12.6344C11.7321 12.2706 11.001 13.0017 11 13.9039V22.4221C11.001 23.3243 11.7321 24.0554 12.6344 24.0564H21.8061C22.7084 24.0554 23.4395 23.3243 23.4405 22.4221V19.5196C23.4405 19.3391 23.2942 19.1928 23.1136 19.1928Z",
    fill: "#4B57E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3116 11.4308C22.7372 10.8564 21.8058 10.8564 21.2314 11.4308L15.3997 17.2625C15.3598 17.3025 15.3309 17.352 15.3159 17.4064L14.549 20.175C14.5174 20.2885 14.5495 20.4101 14.6327 20.4934C14.7161 20.5767 14.8377 20.6087 14.9512 20.5773L17.7198 19.8103C17.7742 19.7953 17.8237 19.7664 17.8637 19.7264L23.6952 13.8947C24.2688 13.3198 24.2688 12.3892 23.6952 11.8144L23.3116 11.4308ZM16.112 17.475L20.8847 12.7021L22.424 14.2413L17.6511 19.0142L16.112 17.475ZM15.8045 18.0919L17.0342 19.3218L15.3332 19.7931L15.8045 18.0919ZM23.233 13.4324L22.8863 13.7791L21.3469 12.2397L21.6937 11.8931C22.0128 11.574 22.5302 11.574 22.8493 11.8931L23.233 12.2766C23.5516 12.5961 23.5516 13.1131 23.233 13.4324Z",
    fill: "#4B57E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit1);
export default __webpack_public_path__ + "static/media/edit1.e75d39135081679014764ccd28820466.svg";
export { ForwardRef as ReactComponent };